export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    staffPreferences() {
      return this.$store.getters['dashboard/getCardStaffPreferences'](this.id);
    },
    safeStaffPreferences() {
      return this.staffPreferences || {};
    },
  },
};
